import { FaPlus } from "react-icons/fa";

import { TokenPoints } from "@bentolabs/points-worker";

import { tokensMeta } from "shared/config/tokens";
import { Button } from "shared/ui/button";
import { Img } from "shared/ui/img";
import { Table } from "shared/ui/table";

type Props = {
  pool: TokenPoints;
};

const formatter = new Intl.NumberFormat("en-US", {
  notation: "compact",
});

export const RowMobile = (props: Props) => {
  const { pool } = props;
  const meta = tokensMeta[pool.token.symbol];

  return (
    <div className="bg-baltic-sea/30 flex flex-col rounded-[10px] p-3.5">
      <div className="flex items-center gap-x-3.5">
        <Img
          className="size-9 shrink-0"
          src={meta?.logoURI}
          alt={pool.token.symbol}
        />
        <div className="flex flex-col">
          <div className="leading leading-none capitalize">
            {pool.token.name}
          </div>
          <div className="text-nobel/70 mt-1 text-sm leading-[150%] capitalize">
            {pool.token.description}
          </div>
        </div>
      </div>

      <Table className="mt-5 gap-y-4">
        <Table.Item label="Balance" value={formatter.format(pool.balance)} />
        <Table.Item label="Total" value={formatter.format(pool.points.value)} />
        <Table.Item
          label="24h Points"
          value={formatter.format(pool.points.rate * 86400)}
        />
      </Table>

      <Button className="mt-5 w-full" variant="spearmint/10">
        <FaPlus className="size-3" /> Deposit
      </Button>
    </div>
  );
};
